import { render, staticRenderFns } from "./SetupInfo.vue?vue&type=template&id=c32bfc58"
import script from "./SetupInfo.vue?vue&type=script&lang=js"
export * from "./SetupInfo.vue?vue&type=script&lang=js"
import style0 from "./SetupInfo.vue?vue&type=style&index=0&id=c32bfc58&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports